
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskTemplateModel } from './Entities.GormCrm.TaskTemplate';
import { TaskflowTemplateTagModel } from './Entities.GormCrm.TaskflowTemplateTag';
import { TaskflowModel } from './Entities.GormCrm.Taskflow';
import { Model, ModelProperty } from 'models/Model';


export class TaskflowTemplateModel extends Model<TaskflowTemplateModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'taskflowTemplate.property.id', isHidden: true },
		{ name: 'title', type: 'string', languageString: 'taskflowTemplate.property.title' },
		{ name: 'created', type: 'Date', languageString: 'taskflowTemplate.property.created', isHidden: true },
		{ name: 'deleted', type: 'Date', languageString: 'taskflowTemplate.property.deleted', isHidden: true },
		{ name: 'taskTemplates', type: 'TaskTemplateModel[]', languageString: 'taskflowTemplate.property.taskTemplates', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskTemplateModel }, properties: () => { return TaskTemplateModel.classProperties } },
		{ name: 'taskflowTemplateTags', type: 'TaskflowTemplateTagModel[]', languageString: 'taskflowTemplate.property.taskflowTemplateTags', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskflowTemplateTagModel }, properties: () => { return TaskflowTemplateTagModel.classProperties } },
		{ name: 'taskflows', type: 'TaskflowModel[]', languageString: 'taskflowTemplate.property.taskflows', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskflowModel }, properties: () => { return TaskflowModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public title: string;
	public created?: Date;
	public deleted?: Date;
	public taskTemplates: TaskTemplateModel[];
	public taskflowTemplateTags: TaskflowTemplateTagModel[];
	public taskflows: TaskflowModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.title = '';
		this.created = undefined;
		this.deleted = undefined;
		this.taskTemplates = [];
		this.taskflowTemplateTags = [];
		this.taskflows = [];
		
	}
	getProperties(){
		return TaskflowTemplateModel.classProperties;
	}
}

